export const actionPlan = {
  "goBack": "Regresar a la lista de planes de acción",
  "title": "Planes de acción",
  byUsers: 'Por usuarios',
  solutionDate: "Tiempo máximo de solución: {{date}}",
  byStores: 'Por unidades',
  successDownloadReport: 'El reporte se descargó exitosamente.',
  errorDownloadReport: 'Ocurrió un error al descargar el reporte.',
  actionPlanResponse: 'Respuestas del plan',
  aprovers: 'Usuarios aprobadores',
  approveAssigned: 'Se reasignaron los usuarios exitosamente',
  emitBy: 'Emitida por',
  rejectBy: 'Rechazado por',
  aproveBy: 'Aprobado por',
  generatedBy: 'Generado por',
  referencedStore: 'Unidad referenciada',
  userSolver: 'ASIGNADO',
  responseDetail: 'Detalle de respuesta',
  rejectMotive: 'Motivo de rechazo',
  evidenceList: 'Listado de evidencias',
  noActionPlan: 'Aún no se han recibido respuestas en este plan de acción',
  timeOut: "Han pasado {{time}} horas y no se han obtenido respuestas de los usuarios aprobadores",
  reassignActionPlan: 'Reasignar plan de acción',
  noAprovers: 'Aún no se han asignado usuarios aprobadores',
  "modal": {
    "title": "Por favor indique el motivo de su rechazo",
    "label": "Motivo del rechazo",
    "cancel": "¿Estás seguro que deseas cancelar este plan de acción?"
  },
  approverTitle: '¿Estás seguro que deseas que los usuarios seleccionados puedan aprobar este plan de acción?',
  approverNotSelecets: 'No hay usuarios seleccionados',
  approverDescription: '',
  tabs: {
    evidence: 'Evidencias',
    item: 'Items'
  },
  "actionPlanOf": {
    "stores": "Por unidades",
    "users": "Por usuarios"
  },
  "snackbar": {
    "cancel": {
      "success": "El plan de acción se cancelo exitosamente",
      "error": "Ocurrió un error al cancelar el plan de acción"
    },
    "approved": {
      "success": "El plan de acción se aprobó exitosamente",
      "error": "Ocurrió un error al aprobar el plan de acción"
    },
    "reject": {
      "success": "El plan de acción se rechazó exitosamente",
      "error": "Ocurrió un error al rechazar el plan de acción"
    }
  }
}